import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
export class SalesViewerListener extends Listener {
    salesViewerInitialized = false;
    pageReady(eventId) {
        if (!TrackingHandler.getInstance().consent.marketing) {
            return;
        }
        this.initializeSalesViewer();
    }
    setConsent(eventId, essential, functional, marketing) {
        if (!marketing) {
            return;
        }
        this.initializeSalesViewer();
    }
    initializeSalesViewer() {
        if (this.salesViewerInitialized) {
            return;
        }
        if (TrackingHandler.getInstance().isInternalTest) {
            return;
        }
        this.salesViewerInitialized = true;
        if (!window.siteSettings.salesViewerId) {
            return;
        }
        (function (s, a, l, e, sv = undefined, i = undefined, ew = undefined, er = undefined) {
            try {
                ((a =
                    s[a] ||
                        s[l] ||
                        function () {
                            throw 'no_xhr';
                        }),
                    (sv = i = 'https://salesviewer.org'),
                    (ew = function (x) {
                        ((s = new Image()),
                            (s.src =
                                'https://salesviewer.org/tle.gif?sva=' +
                                    window.siteSettings.salesViewerId +
                                    '&u=' +
                                    encodeURIComponent(window.location.toString()) +
                                    '&e=' +
                                    encodeURIComponent(x)));
                    }),
                    (l = s.SV_XHR =
                        function (d) {
                            return ((er = new a()),
                                (er.onerror = function () {
                                    if (sv != i)
                                        return ew('load_err');
                                    ((sv = 'https://www.salesviewer.com/t'), setTimeout(l.bind(null, d), 0));
                                }),
                                (er.onload = function () {
                                    (s.execScript || s.eval).call(er, er.responseText);
                                }),
                                er.open('POST', sv, !0),
                                (er.withCredentials = true),
                                er.send(d),
                                er);
                        }),
                    l('h_json=' +
                        (typeof JSON.parse === 'function' ? '1' : '0') +
                        '&h_wc=1&h_event=' +
                        (typeof addEventListener === 'function' ? '1' : '0') +
                        '&sva=' +
                        e));
            }
            catch (x) {
                ew(x);
            }
        })(window, 'XDomainRequest', 'XMLHttpRequest', window.siteSettings.salesViewerId);
    }
}
